import { flatMap } from 'lodash';

import { jsonParse } from '@lyearn/core/utils/json';
import { useFetchConfig } from '@/components/ConfigsProvider';
import { NavbarMenuChild } from '@/types/schema';

export default function useDefaultWidgetId() {
  const { navConfig } = useFetchConfig(['navConfig']);

  const menuPages = flatMap(navConfig?.children, (item) => {
    if (item.children?.length) {
      return item.children;
    }
    return [item] as NavbarMenuChild[];
  }).find((item) => item.key === 'library');

  const { data: properties } = jsonParse<{
    defaultWidgetId: string;
    defaultWidgetType: string;
  }>(menuPages?.props ?? '{}');

  return {
    defaultWidgetId: (properties?.['defaultWidgetId'] ?? '') as string,
    defaultWidgetType: (properties?.['defaultWidgetType'] ?? '') as string,
  };
}
